import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import PlaceServices from "../../services/externalServices/TourPackageServices/placeServices";

function AddPlace({
  openAddPlaceDialog,
  handleAddPlaceDialogClose,
  fetchAllPlaces,
}) {
  const [newPlace, setNewPlace] = useState({
    fullName: {
      en: "",
      kn: "",
      te: "",
      ta: "",
      ml: "",
      hi: ""
    },
    shortName: {
      en: "",
      kn: "",
      te: "",
      ta: "",
      ml: "",
      hi: ""
    },
    description: {
      en: "",
      kn: "",
      te: "",
      ta: "",
      ml: "",
      hi: ""
    },
    thumbnailImage: null,
    iconName: "map-marker",
    sliderImages: ["", "", ""], // Slider images
    featureMediaType: "",
    featureMediaURL: "",
    location: {
      latitude: 0,
      longitude: 0
    },
    nearbyPlaces: {
      en: ["", "", ""],
      kn: ["", "", ""],
      te: ["", "", ""],
      ta: ["", "", ""],
      ml: ["", "", ""],
      hi: ["", "", ""]
    },
    openTimings: {
      en: "",
      kn: "",
      te: "",
      ta: "",
      ml: "",
      hi: ""
    },
    message: {
      en: "",
      kn: "",
      te: "",
      ta: "",
      ml: "",
      hi: ""
    },
    tips: {
      en: ["", "", ""],
      kn: ["", "", ""],
      te: ["", "", ""],
      ta: ["", "", ""],
      ml: ["", "", ""],
      hi: ["", "", ""]
    },
    rules: {
      en: ["", "", ""],
      kn: ["", "", ""],
      te: ["", "", ""],
      ta: ["", "", ""],
      ml: ["", "", ""],
      hi: ["", "", ""]
    },
    tags: {
      en: ["", "", ""],
      kn: ["", "", ""],
      te: ["", "", ""],
      ta: ["", "", ""],
      ml: ["", "", ""],
      hi: ["", "", ""]
    },
    approxVisitTime: 0,
    requiresEntryFee: false,
    internalComments: "Added by Raj",
    isEnabled: true
  });
  

  const [errors, setErrors] = useState({}); // State to store error messages
  const [selectedLanguage, setSelectedLanguage] = useState("en");

  // const handleNewPlaceChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === "location") {
  //     setNewPlace((prev) => ({
  //       ...prev,
  //       location: {
  //         ...prev.location,
  //         [e.target.dataset.field]: value,
  //       },
  //     }));
  //   } else if (
  //     name.startsWith("sliderImages") ||
  //     name.startsWith("tips") ||
  //     name.startsWith("rules") ||
  //     name.startsWith("tags") ||
  //     name.startsWith("nearbyPlaces")
  //   ) {
  //     const fieldName = name.split("-")[0];
  //     const index = parseInt(name.split("-")[1], 10);
  //     const updatedArray = [...newPlace[fieldName]];
  //     updatedArray[index] = value;
  //     setNewPlace((prev) => ({
  //       ...prev,
  //       [fieldName]: updatedArray,
  //     }));
  //   } else if (name === "requiresEntryFee") {
  //     setNewPlace((prev) => ({
  //       ...prev,
  //       [name]: e.target.checked,
  //     }));
  //   } else {
  //     setNewPlace((prev) => ({
  //       ...prev,
  //       [name]: value,
  //     }));
  //   }
  // };

  const handleNewPlaceChange = (e) => {
    const { name, value, type, checked } = e.target;
    const language = "en"; // Use the current selected language here
  // console.log("checked value",checked)
    if (name === "location") {
      setNewPlace((prev) => ({
        ...prev,
        location: {
          ...prev.location,
          [e.target.dataset.field]: value,
        },
      }));
    } else if (name.startsWith("sliderImages") ) {
      const fieldName = name.split("-")[0];
      const index = parseInt(name.split("-")[1], 10);
      const updatedArray = [...newPlace[fieldName]];
      updatedArray[index] = value;
      setNewPlace((prev) => ({
        ...prev,
        [fieldName]: updatedArray,
      }));
    }else if (name.startsWith("nearbyPlaces") || name.startsWith("tags") || name.startsWith("rules")|| name.startsWith("tips")) {
      // For fields like nearbyPlaces, tags, or rules that have array values
      const fieldName = name.split("-")[0];
      const index = parseInt(name.split("-")[1], 10);  // Assuming the index of the array item
      setNewPlace((prev) => ({
        ...prev,
        [fieldName]: {
          ...prev[fieldName],
          [language]: [
            ...prev[fieldName][language].slice(0, index),
            value,  // Update the specific item at the index
            ...prev[fieldName][language].slice(index + 1),  // Ensure the other items remain intact
          ],
        },
      }));
    }
     else if (name.includes("fullName") || name.includes("shortName") || name.includes("description") || name.includes("message") || name.includes("openTimings") ){
      const fieldName = name.split("-")[0];
      setNewPlace((prev) => ({
        ...prev,
        [fieldName]: {
          ...prev[fieldName],
          [selectedLanguage]: value, // Update the specific language field
        },
      }));
    } else if (name === "requiresEntryFee") {
      setNewPlace((prev) => ({
        ...prev,
        [name]: checked,  // Here we directly use 'checked' which is a boolean value
      }));
    }else {
      setNewPlace((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleAddField = (field) => {
    setNewPlace((prev) => ({
      ...prev,
      [field]: [...prev[field], ""],
    }));
  };
  const handleLanguageChange = (event) => {
    setSelectedLanguage(event.target.value); // Update the selected language
  };

  // Validation function
  const validateFields = () => {
    const newErrors = {};
    if (!newPlace.fullName) newErrors.fullName = "Full Name is required";
    if (!newPlace.shortName) newErrors.shortName = "Short Name is required";
    if (!newPlace.description)
      newErrors.description = "Description is required";
    if (!newPlace.thumbnailImage)
      newErrors.thumbnailImage = "Thumbnail Image is required";
    // Latitude and Longitude Validation (Required and Type Number)
    if (!newPlace.location.latitude || isNaN(newPlace.location.latitude)) {
      newErrors.location = "Latitude is required and must be a number";
    }
    if (!newPlace.location.longitude || isNaN(newPlace.location.longitude)) {
      newErrors.location = "Longitude is required and must be a number";
    }
    if (newPlace.sliderImages.some((img) => !img)) {
      newErrors.sliderImages = "All Slider Images must be provided";
    }
    if (newPlace.approxVisitTime <= 0) {
      newErrors.approxVisitTime = "Approx Visit Time must be a positive number";
    }
    if (!newPlace.internalComments)
      newErrors.internalComments = "Internal Comments are required";
    if (!newPlace.featureMediaType)
      newErrors.featureMediaType = "Feature Media Type is required";
    if (!newPlace.featureMediaURL)
      newErrors.featureMediaURL = "Feature Media URL is required";
    return newErrors;
  };

  const handleSaveNewPlace = async () => {
    const validationErrors = validateFields();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors); // Set errors if validation fails
      return;
    }

    try {
      const response = await PlaceServices.addPlace(newPlace);
      console.log("New place added:", response);
      fetchAllPlaces();
      handleAddPlaceDialogClose();
    } catch (error) {
      console.error("Error adding new place:", error);
    }
  };

  return (
    <Dialog open={openAddPlaceDialog} onClose={handleAddPlaceDialogClose}>
      <DialogTitle>Add a New Place</DialogTitle>
  {/* Language Dropdown */}
  <FormControl sx={{ mb: 3 }} fullWidth>
        <InputLabel id="language-select-label">Language</InputLabel>
        <Select
          labelId="language-select-label"
          value={selectedLanguage}
          onChange={handleLanguageChange}
          label="Language"
        >
          <MenuItem value="en">English</MenuItem>
          <MenuItem value="kn">Kannada</MenuItem>
          <MenuItem value="te">Telugu</MenuItem>
          <MenuItem value="ta">Tamil</MenuItem>
          <MenuItem value="ml">Malayalam</MenuItem>
          <MenuItem value="hi">Hindi</MenuItem>
        </Select>
      </FormControl>


      <DialogContent>
        {/* Basic Fields */}
        <TextField
          label="Full Name"
          name="fullName"
          value={newPlace.fullName[selectedLanguage]}
          onChange={handleNewPlaceChange}
          fullWidth
          sx={{ mb: 2 }}
          error={!!errors.fullName}
          helperText={errors.fullName}
        />
        <TextField
          label="Short Name"
          name="shortName"
          value={newPlace.shortName[selectedLanguage]}
          onChange={handleNewPlaceChange}
          fullWidth
          sx={{ mb: 2 }}
          error={!!errors.shortName}
          helperText={errors.shortName}
        />
        <TextField
          label="Description"
          name="description"
          value={newPlace.description[selectedLanguage]}
          onChange={handleNewPlaceChange}
          fullWidth
          multiline
          rows={4}
          sx={{ mb: 2 }}
          error={!!errors.description}
          helperText={errors.description}
        />
        <TextField
          label="Thumbnail Image URL"
          name="thumbnailImage"
          value={newPlace.thumbnailImage}
          onChange={handleNewPlaceChange}
          fullWidth
          sx={{ mb: 2 }}
          error={!!errors.thumbnailImage}
          helperText={errors.thumbnailImage}
        />

        {/* Slider Images */}
        {newPlace.sliderImages.map((image, index) => (
          <TextField
            key={`sliderImage-${index}`}
            label={`Slider Image ${index + 1} URL`}
            name={`sliderImages-${index}`}
            value={image}
            onChange={handleNewPlaceChange}
            fullWidth
            sx={{ mb: 2 }}
            error={!!errors.sliderImages}
            helperText={errors.sliderImages}
          />
        ))}
        <Button
          onClick={() => handleAddField("sliderImages")}
          color="primary"
          sx={{ mb: 2 }}
        >
          Add Image
        </Button>

        {/* Location */}
        <TextField
          label="Latitude"
          name="location"
          data-field="latitude"
          value={newPlace.location.latitude}
          onChange={(e) =>
            setNewPlace((prevState) => ({
              ...prevState,
              location: {
                ...prevState.location,
                latitude: e.target.value,
              },
            }))
          }
          fullWidth
          sx={{ mb: 2 }}
          error={!!errors.location}
          helperText={errors.location}
        />
        <TextField
          label="Longitude"
          name="location"
          data-field="longitude"
          value={newPlace.location.longitude}
          onChange={(e) =>
            setNewPlace((prevState) => ({
              ...prevState,
              location: {
                ...prevState.location,
                longitude: e.target.value,
              },
            }))
          }
          fullWidth
          sx={{ mb: 2 }}
          error={!!errors.location}
          helperText={errors.location}
        />

        {/* Nearby Places */}
        {newPlace.nearbyPlaces[selectedLanguage].map((place, index) => (
          <TextField
            key={`nearbyPlace-${index}`}
            label={`Nearby Place ${index + 1}`}
            name={`nearbyPlaces-${index}`}
            value={place}
            onChange={handleNewPlaceChange}
            fullWidth
            sx={{ mb: 2 }}
          />
        ))}
        <Button
          onClick={() => handleAddField("nearbyPlaces")}
          color="primary"
          sx={{ mb: 2 }}
        >
          Add Nearby Place
        </Button>

        {/* Other Fields */}
        <TextField
          label="Open Timings"
          name="openTimings"
          value={newPlace.openTimings[selectedLanguage]}
          onChange={handleNewPlaceChange}
          fullWidth
          sx={{ mb: 2 }}
        />
        <TextField
          label="Message"
          name="message"
          value={newPlace.message[selectedLanguage]}
          onChange={handleNewPlaceChange}
          fullWidth
          sx={{ mb: 2 }}
        />
        <FormControlLabel
          control={
            <Checkbox
              name="requiresEntryFee"
              checked={newPlace.requiresEntryFee}
              onChange={handleNewPlaceChange}
            />
          }
          label="Requires Entry Fee"
          sx={{ mb: 2 }}
        />
        <TextField
          label="Approx Visit Time (minutes)"
          name="approxVisitTime"
          type="number"
          value={newPlace.approxVisitTime}
          onChange={handleNewPlaceChange}
          fullWidth
          sx={{ mb: 2 }}
        />
        <TextField
          label="Internal Comments"
          name="internalComments"
          value={newPlace.internalComments}
          onChange={handleNewPlaceChange}
          fullWidth
          sx={{ mb: 2 }}
          error={!!errors.internalComments}
          helperText={errors.internalComments}
        />
        <TextField
          label="Feature Media Type"
          name="featureMediaType"
          value={newPlace.featureMediaType}
          onChange={handleNewPlaceChange}
          fullWidth
          sx={{ mb: 2 }}
          error={!!errors.featureMediaType}
          helperText={errors.featureMediaType}
        />
        <TextField
          label="Feature Media URL"
          name="featureMediaURL"
          value={newPlace.featureMediaURL}
          onChange={handleNewPlaceChange}
          fullWidth
          sx={{ mb: 2 }}
          error={!!errors.featureMediaURL}
          helperText={errors.featureMediaURL}
        />

        {/* Tips, Rules, and Tags */}
        {["tips", "rules", "tags"].map((field) => (
          <React.Fragment key={field}>
            {newPlace[field][selectedLanguage].map((item, index) => (
              <TextField
                key={`${field}-${index}`}
                label={`${field.charAt(0).toUpperCase() + field.slice(1)} ${
                  index + 1
                }`}
                name={`${field}-${index}`}
                value={item}
                onChange={handleNewPlaceChange}
                fullWidth
                sx={{ mb: 2 }}
              />
            ))}
            <Button
              onClick={() => handleAddField(field)}
              color="primary"
              sx={{ mb: 2 }}
            >
              {/* Add {field.charAt(0).toUpperCase() + field.slice(1)} */}
            </Button>
          </React.Fragment>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleAddPlaceDialogClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSaveNewPlace} color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddPlace;
